import { fetchWithHeaders, HTTP_METHODS, parseErrorResponse, responseData } from "@/utils/httpRequest";

export function fetchLenderClosingReasons() {
  return fetchWithHeaders("/parameters/lender-call-log-lender-closing-reasons", {
    method: HTTP_METHODS.GET,
  })
    .then(responseData)
    .catch(parseErrorResponse);
}
